export class AsyncLock {
	private _promise: Promise<void> = Promise.resolve();
	private _disable = () => { };

	public Lock(): void {
		this._promise = new Promise(resolve => this._disable = resolve);
	}

	public Unlock(): void {
		this._disable();
	}

	public WaitForLockAsync(): Promise<void> {
		return this._promise;
	}
}